export default {"src":"/_next/static/media/WhoWeAre_043A.a3260c5f.JPG","height":688,"width":1920};